// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"36":"16ef4e52b554c60f","43":"6a731593fdaccc06","147":"fd9a3daff458888d","334":"669a261380374549","608":"088659e042208b5c","765":"6ea9a47eaab3f809","958":"3b3dbee3496b80d5"}[chunkId] + ".js";
};